const processingCard = "mb-4 shrink-0";

const processingPulse = "h-2 w-2 rounded-full bg-warning shrink-0 mr-1.5";

const processingHeader =
  "flex items-center justify-between px-4 py-3 text-xs font-semibold text-muted-foreground uppercase tracking-wider border-b border-border/60 shrink-0";

const processingCancel = "ml-auto px-2 py-0.5 text-xs font-medium text-destructive hover:text-destructive/80 transition-colors";

const logContent = "p-0";

const twoFaContainer = "mt-3 pt-3 border-t border-border/60";

const twoFaHeader = "flex items-center gap-2 mb-2";

const twoFaInputGroup = "flex gap-2";

const twoFaInput =
  "flex-1 px-3 py-1.5 text-sm border border-warning/50 rounded-md bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-warning/50";

const twoFaSubmit = "px-3 py-1.5 text-sm font-medium bg-secondary text-foreground rounded-md hover:bg-accent transition-colors";

const twoFaCancel = "px-3 py-1.5 text-sm text-destructive hover:text-destructive/80 transition-colors";

const twoFaTitle = "text-xs font-semibold text-warning";

const errorText = "text-destructive font-normal";

export {
  processingCard,
  processingPulse,
  processingHeader,
  processingCancel,
  logContent,
  twoFaContainer,
  twoFaHeader,
  twoFaInputGroup,
  twoFaInput,
  twoFaSubmit,
  twoFaCancel,
  twoFaTitle,
  errorText,
};
